"use client";
import * as React from "react";
const SvgOpenSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m9.51 0 .01 2h3.06L2 12.58V9.52H0V16h6.49l-.01-2H3.42L14 3.42v3.06h1.99L16 0z" }));
export {
  SvgOpenSharp as default
};
